import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/licitaciones")({
  component: LicitacionesLayout,
});

export function LicitacionesLayout() {
  return <Outlet />;
}